import controller from './products-manage.controller';
import template from './products-manage.html';
import './products-manage.less';

const component = {
    template,
    bindings: {
        edit: '<?',
    },
    controller: [
        '$state',
        '$uibModal',
        '$sce',
        'crConfig',
        'crConstants',
        'crEntityService',
        'crLocaleService',
        'crNavigationService',
        'crErrorLoggingService',
        'crAnalyticsService',
        'crCommerceService',
        controller,
    ],
};

export default component;
